import { debugFactory } from '@iva/debugger';
// debugger
const config = {
    name: 'IdentityStorage',
    fColor: 'white',
    bColor: '#ccc',
};
const debug = debugFactory(config);
// logger
let dotInstance = null;
const initDot = () => {
    if (window.DOT) {
        dotInstance = window.DOT.getNewInstance();
        dotInstance.cfg({ service: 'idt', mousedown: false, load: false, impress: false });
    }
};
const dotLog = (data) => {
    if (!dotInstance) {
        initDot();
    }
    dotInstance === null || dotInstance === void 0 ? void 0 : dotInstance.hit('event', data);
};
export { debug, dotLog };
